import React from 'react';
import { TextField } from '@mui/material';

export const TextFieldBlock = ({ setting, onValueChange, controlSize = 'small', fullWidth = false }) => {
    const handleChange = (event) => {
        onValueChange(setting.id, event.target.value, setting.parameter_type);
    };

    const inputType = setting.type === 'number' ? 'number' : 'text';

    return (
        <TextField
            disabled={!setting.is_active}
            type={inputType}
            value={setting.parameter_value || ""}
            onChange={handleChange}
            variant="outlined"
            size={controlSize}
            fullWidth={fullWidth}
            inputProps={{
                "aria-label": `input ${setting.title}`,
            }}
        />
    );
};
